import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'

import { Subscription } from 'rxjs'
import { NotificationService } from 'src/app/modules/commons/components/notification/services/notification.service'
import { MachineStateComputed } from '../../models/states-computed.models'
import { TouaregControlDisplayService } from '../../services/touareg-control-display.service'
import {
  HealthMonitorData,
  TouaregControlStateHealthMonitorService,
} from '../../services/touareg-control-state-health-monitor.service'
import { TouaregControlStateMachineService } from '../../services/touareg-control-state-machine.service'
import { TouaregControlToolbarComponent } from '../touareg-control-toolbar/touareg-control-toolbar.component';
import { TouaregControlStateIdleComponent } from './states/state-idle/touareg-control-state-idle.component';
import { TouaregControlStatePickCandidateComponent } from './states/state-pick-candidate/touareg-control-state-pick-candidate.component';
import { TouaregControlStatePickComponent } from './states/state-pick/touareg-control-state-pick.component';
import { TouaregControlStateDropComponent } from './states/state-drop/touareg-control-state-drop.component';
import { TouaregControlStateAcceptingUserChoiceComponent } from './states/state-accepting-user-choice/touareg-control-state-accepting-user-choice.component';
import { TouaregControlStateDropBlockedByUserComponent } from './states/state-drop-blocked-by-user/touareg-control-state-drop-blocked-by-user.component';
import { TouaregControlStateLayoutComponent } from './layout/touareg-control-state-layout.component';
import { Samv2Module } from '@aubert-et-duval/samv2';

@Component({
  selector: 'app-touareg-control-states',
  templateUrl: './touareg-control-states.component.html',
  styleUrls: ['./touareg-control-states.component.scss'],
  imports: [TouaregControlToolbarComponent, TouaregControlStateIdleComponent, TouaregControlStatePickCandidateComponent, TouaregControlStatePickComponent, TouaregControlStateDropComponent, TouaregControlStateAcceptingUserChoiceComponent, TouaregControlStateDropBlockedByUserComponent, TouaregControlStateLayoutComponent, Samv2Module],
})
export class TouaregControlStatesComponent implements OnInit, OnDestroy {
  @Output() close = new EventEmitter<MouseEvent>()

  private _touaregStatesSubs$!: Subscription
  private _touaregHealthSubs$!: Subscription

  public currentState: MachineStateComputed | null | undefined
  public health!: HealthMonitorData

  constructor(
    private _stateMachine: TouaregControlStateMachineService,
    private _monitor: TouaregControlStateHealthMonitorService, // private _notify: NotificationService,
    private _display: TouaregControlDisplayService
  ) {}

  ngOnInit(): void {
    this._touaregStatesSubs$ = this._stateMachine.stateMachine$.subscribe(
      (state) => {
        this.currentState = state
      }
    )
    this._touaregHealthSubs$ = this._monitor.health$.subscribe((health) => {
      this.health = health
    })
  }

  public onWaitingComplete() {
    if (!this._display.display?.openByUser) {
      this._display.closeUI()
    }
    // this._display.setNotificationToRemove(
    //   this._notify.pushInfo('Collecting drop information.')
    // )
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (!!this._touaregStatesSubs$) this._touaregStatesSubs$.unsubscribe()
    if (!!this._touaregHealthSubs$) this._touaregHealthSubs$.unsubscribe()
  }
}
